import get from 'lodash/get';
import { MARKER_STATUS_MODE } from 'platform-components/constants';
import { ROBOT_TABS } from 'platform-components/src/components/robot/robot.types';
import { getIsContentManager } from 'platform-components/src/components/user/selectors';
import React from 'react';
import { useSelector } from 'react-redux';

import { ProblemWithLabView } from 'common.components/lab-problem/lab-problem';
import { LessonProblemWithResult } from 'common.components/student-lesson-stat/typings';

import { useLessonContentSelector } from '../selectors';

import './lesson-content__problem.scss';

interface Props {
    correctAnswersAvailable: boolean;
    itemLink: LessonProblemWithResult;
    mix?: string;
}

export function LessonContentProblem(props: Props) {
    const { itemLink, correctAnswersAvailable } = props;
    const isContentManager = useSelector(getIsContentManager);
    const showCorrectAnswers = useLessonContentSelector((s) => itemLink.id in s.showCorrectAnswersForProblems);

    const problem = itemLink.problem;
    const hasAttempts = Boolean(problem?.attempt?.answered);

    function getStatusMode() {
        if (correctAnswersAvailable && showCorrectAnswers) {
            return MARKER_STATUS_MODE.EVERYTHING_IS_CORRECT;
        } else if (correctAnswersAvailable && hasAttempts) {
            return MARKER_STATUS_MODE.WITHOUT_SKIPPED;
        }
        return MARKER_STATUS_MODE.NORMAL;
    }

    return (
        <div className="lesson-content__problem">
            <ProblemWithLabView
                {...props}
                // @ts-ignore Property 'displayCmComment' does not exist
                displayCmComment
                displayPublicSolution
                displaySolution
                maxPoints={get(itemLink, ['options', 'max_points'], get(problem, 'max_points'))}
                problem={problem}
                robotInitialTab={ROBOT_TABS.CODE}
                shouldShowProblemId={isContentManager}
                showCmComment
                showCorrectAnswers={correctAnswersAvailable && showCorrectAnswers}
                showCurrentAnswersStatus={true}
                showPublicSolution
                showSolution
                statusMode={getStatusMode()}
            />
        </div>
    );
}
